import { useEffect } from 'react';
import { useOpen } from './useOpen';
import { eventSubscription } from '../utils/events/eventSubscription';

export const useOpenLink = () => {
  const openLink = useOpen();

  useEffect(
    () =>
      eventSubscription({
        callbacksBus: [
          {
            event: 'click',
            callback(e) {
              if (!e.target.matches('a *') && !e.target.matches('a')) return;
              e.preventDefault();
              const href = e.target.closest('a').getAttribute('href');
              openLink(href);
            },
            options: { capture: true },
          },
        ],
      }),
    [],
  );
};
